import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function LongTestimonials() {
  const testimonials = [{
    text: 'Soy psicopedagoga hace 8 años y nunca tuve un material tan completo. Lo que más me sorprendió es que no es solo un montón de actividades: está todo pensado, secuenciado, con objetivos claros. Las rúbricas me salvaron la vida en los informes del primer trimestre. Antes tardaba todo el fin de semana, ahora en dos horas tengo todo listo.',
    author: 'L.M., Mendoza',
    role: 'Psicopedagoga clínica y escolar'
  }, {
    text: 'Trabajo en una sala de 4 años con 28 nenes y siempre llegaba a marzo sin nada armado. Este año compré el MegaPack y fue un antes y un después. Tengo todo el año planificado, las actividades ya vienen con adaptaciones por nivel, y los materiales imprimibles son hermosos. Mis compañeras me preguntan de dónde saco todo.',
    author: 'C.R., Tucumán',
    role: 'Docente de nivel inicial'
  }, {
    text: 'Lo compré medio escéptica porque ya tengo Pinterest y mil carpetas con cosas guardadas. Pero la diferencia es que esto es un SISTEMA. No son actividades sueltas, es un plan completo con secuencia didáctica, objetivos, evaluación, todo. Y los bonos de comunicación con familias son oro puro. Las plantillas de informes me ahorraron horas.',
    author: 'M.V., Mar del Plata',
    role: 'Psicopedagoga institucional'
  }, {
    text: 'Soy docente integradora y siempre me costaba encontrar material adaptado. Acá cada actividad ya viene con tres niveles de dificultad y sugerencias de adaptación. Es justo lo que necesitaba. Además, los protocolos de intervención son súper claros y prácticos. Lo recomiendo 100%.',
    author: 'J.P., Neuquén',
    role: 'Docente de apoyo a la integración'
  }, {
    text: 'Arranqué el año con todo listo gracias al MegaPack. Las secuencias de rutinas y hábitos del Tomo 2 me ayudaron un montón en abril y mayo. Los chicos instalaron las rutinas re rápido porque las actividades están pensadas para eso. Y el planificador anual es una joya, lo tengo colgado en mi escritorio.',
    author: 'A.S., Salta',
    role: 'Docente de sala de 3'
  }, {
    text: 'Lo mejor es que no tengo que pensar qué hacer cada semana. Abro el tomo que corresponde, veo la secuencia, imprimo el material y listo. Me sobra tiempo para preparar mejor las clases en vez de estar buscando actividades. Y las fichas de seguimiento individual son perfectas para los informes.',
    author: 'N.G., La Plata',
    role: 'Psicopedagoga y docente'
  }, {
    text: 'Compré la versión PRO y no me arrepiento. El Kit de Dirección y Familias me sirvió un montón para las reuniones con padres. Las guías paso a paso te dicen exactamente qué decir y cómo estructurar la reunión. Y las actas ya vienen armadas, solo completás. Es profesionalismo puro.',
    author: 'F.L., Corrientes',
    role: 'Psicopedagoga y coordinadora de nivel'
  }, {
    text: 'Trabajo en dos jardines y siempre andaba corriendo. Con el MegaPack tengo todo organizado y puedo usar el mismo material adaptándolo a cada sala. Las plantillas editables son un golazo. Y el soporte por mail es excelente, me respondieron todas las dudas al toque.',
    author: 'V.D., Bahía Blanca',
    role: 'Docente de sala de 5'
  }, {
    text: 'Lo que más valoro es que está pensado para Argentina. Los contenidos están alineados con los NAP y las currículas provinciales. No es material genérico traducido, es nuestro. Y se nota. Las actividades tienen sentido para nuestro contexto y nuestros chicos.',
    author: 'R.T., San Juan',
    role: 'Psicopedagoga y capacitadora docente'
  }, {
    text: 'Soy docente hace 15 años y este es el material más completo que vi. No solo tenés actividades, tenés TODO: objetivos, secuencias, evaluación, comunicación con familias, organización docente. Es como tener una mentora que te dice exactamente qué hacer y cómo hacerlo. Lo recomiendo a todas mis colegas.',
    author: 'S.B., Posadas',
    role: 'Docente de nivel inicial y formadora'
  }];
  return <section className="w-full py-6 bg-[#111111]" data-id="element-176">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-177">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-2 text-center" data-id="element-178">
          Lo que dicen las profesionales que ya lo usan
        </h2>
        <p className="text-center text-gray-400 mb-5 text-sm" data-id="element-179">
          Testimonios reales de psicopedagogas y docentes de todo el país
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-180">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-[#1A1A1A] p-4 rounded-lg border-l-4 border-[#D4A843]" data-id="element-181">
              <QuoteIcon className="w-5 h-5 text-[#D4A843]/40 mb-2" data-id="element-182" />
              <p className="text-gray-300 mb-3 leading-relaxed italic text-sm" data-id="element-183">
                "{testimonial.text}"
              </p>
              <div className="border-t border-[#2A2A2A] pt-3" data-id="element-184">
                <div className="font-semibold text-white text-sm" data-id="element-185">
                  {testimonial.author}
                </div>
                <div className="text-xs text-[#D4A843]" data-id="element-186">{testimonial.role}</div>
                <div className="text-[10px] text-gray-500 mt-1" data-id="element-187">EJEMPLO</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}